import AccordionItem from "@components/common/accordion-item/AccordionItem";
import { PATHS } from "@constants/Paths";
import { PeekIconButton } from "@piiqtechnologies/ui-components";
import { Policy } from "@piiqtechnologies/ui-lib";
import { Settings as SettingsIcon } from "@piiqtechnologies/svg-icons";
import React from "react";
import { useNavigate } from "react-router-dom";
export const CommunityPanel = ({ onChange, expanded, communityId, title, children, disabled, }) => {
    const navigate = useNavigate();
    const onSettingsClick = () => {
        navigate(`${PATHS.COMMUNITIES}/${communityId}/${PATHS.COMMUNITY_SETTINGS_SGT}`);
    };
    return (React.createElement(AccordionItem, { title: title, expanded: expanded, onChange: onChange, disabled: disabled, actionIcon: React.createElement(Policy, { action: "community_write" /* PolicyActions.COMMUNITY_WRITE */, mode: "disable" },
            React.createElement(PeekIconButton, { sx: {
                    color: "primary.main",
                    "&.Mui-disabled": { color: "info.light" },
                }, bordered: false, onClick: (e) => {
                    e.stopPropagation();
                    onSettingsClick();
                } },
                React.createElement(SettingsIcon, { width: 18, height: 18 }))) }, children));
};
export default CommunityPanel;
